import en from "../../public/locales/en/translation.json";
import ar from "../../public/locales/ar/translation.json";

const translations = { en, ar } as const;
type Locale = keyof typeof translations;

export function resolveKey(locale: string, key: string): string {
  const dict = translations[locale as Locale] ?? translations.en;
  let value: any = dict;
  for (const k of key.split(".")) {
    if (value && typeof value === "object") {
      value = value[k];
    } else {
      return key;
    }
  }
  return typeof value === "string" ? value : key;
}

export function getTranslation(locale: string) {
  return (key: string) => resolveKey(locale, key);
}
